import { render, staticRenderFns } from "./AddCourseDialog.vue?vue&type=template&id=ec1d409a&scoped=true"
import script from "./AddCourseDialog.vue?vue&type=script&lang=js"
export * from "./AddCourseDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCourseDialog.vue?vue&type=style&index=0&id=ec1d409a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d409a",
  null
  
)

export default component.exports